exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-79e73fda]:export{menuText:#bfcbd9;menuActiveText:#409EFF;subMenuActiveText:#f4f4f5;menuBg:#304156;menuHover:#263445;subMenuBg:#1f2d3d;subMenuHover:#001528;sideBarWidth:210px;bgColor:#F2F3F5;fontColor:#409EFF;searchBg:#fff}.party[data-v-79e73fda]{font-weight:bold;padding:10px 0;border-bottom:1px solid #606266}.send-link-style[data-v-79e73fda] .el-checkbox__input.is-disabled+span.el-checkbox__label{color:#409EFF}\n", ""]);

// exports
